import type { CSSProperties } from "react";
import React from "react";

import { locales, WaterlyLocale } from "@waterly/locales";

import logoImg from "../assets/rounds-logo-white-splash.png";

import { LoadingAnimation } from "./loadingAnimation";

/**
 * This loader very specifically should *not* incorporate material-ui or other
 * larger libraries, as it is used primarily in Suspense fallbacks to allow for
 * a better experience while lazy-loading larger libraries and components.
 * (Inline styles aren't very nice, but in use here to avoid importing mui-styles)
 */

const styles: Record<string, CSSProperties> = {
  loaderMain: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyItems: "center",

    width: "100vw",
    height: "100vh",

    backgroundColor: "#1c2b35",
  },

  loaderContent: {
    margin: "auto",
    color: "white",
  },

  loaderContentH1: {
    fontSize: 20,
    display: "flex",
    margin: "0 10px",
    flexShrink: 1,
  },

  loaderMainLogo: {
    minWidth: 400,
    width: 600,
    maxWidth: `calc(100vw - 40px)`,
    height: 80,
  },

  loaderText: {
    display: "flex",
    flexDirection: "row",
    // width: "100%",
    height: 30,
    marginTop: 10,

    alignItems: "center",
    justifyItems: "center",
    alignContent: "center",
  },

  loaderTextSpacer: {
    flexGrow: 1,
  },
};

const VALID_LOCALES: ReadonlySet<string> = new Set(Object.values(WaterlyLocale));

function isValidLocale(value: string | null): value is WaterlyLocale {
  return value !== null && VALID_LOCALES.has(value);
}

export const FullScreenLoader: React.FC = () => {
  const rawLocale = localStorage.getItem("locale");
  const locale = isValidLocale(rawLocale) ? rawLocale : null;
  const loadingLabel =
    locales[locale ?? WaterlyLocale.enUS]?.common.loading_ellipses ??
    locales[WaterlyLocale.enUS].common.loading_ellipses;

  return (
    <main style={styles.loaderMain}>
      <div style={styles.loaderContent}>
        <div style={styles.loaderMainLogo}>
          <img src={logoImg} alt="Waterly Logo" style={{ height: "auto", width: "100%" }} />
        </div>
        <div style={styles.loaderText}>
          <div style={styles.loaderTextSpacer} />
          {/* Read directly from the locale bundle so this fallback stays translated without bootstrapping i18n. */}
          <h1 style={styles.loaderContentH1}>{loadingLabel}</h1>
          <LoadingAnimation />
        </div>
      </div>
    </main>
  );
};
